module.exports = __webpack_public_path__ + "img/icon-light-track-white.f02be2df.svg";